export class PessoaFisicaSisbi {
    csSexo: string;
    dtExpedicaoRg: string;
    dtNascimento: string;
    idPessoaFisica: number;
    nmExpedidorRg: string;
    nmPessoaFisica: string;
    nrCpf: string;
    nrRg: string;
    sgUfExpedidorRg: string;

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): PessoaFisicaSisbi {
        return Object.assign(new PessoaFisicaSisbi(), jsonData);
    }
}
